import { type RefObject, useLayoutEffect, useState } from 'react'

// Observes changes to the bounding box of a given element
// see https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
export const useRect = <T extends Element>(ref: RefObject<T | null>): DOMRect | null => {
  const [rect, setRect] = useState<DOMRect | null>(null)

  useLayoutEffect(() => {
    if (!ref.current) return
    setRect(ref.current.getBoundingClientRect())
  }, [ref])

  return rect
}
